export default "__VITE_ASSET__KoqCW$RI__"